import { options } from '@master/model/options/Options'

const options = ['Yes', 'No', 'NA']
export const DefaultOptions: options[] = options.map(option => {
  return {
    label: option,
    value: option.toLowerCase()
  }
})

export const YesNoOptions: options[] = options.filter(option => option !== 'NA').map(option => {
  return {
    label: option,
    value: option.toLowerCase()
  }
})

export const YesNoBlankOptions: options[] = [{ label: '', value: undefined }].concat(YesNoOptions)

export const YesNaOptions: options[] = options.filter(option => option !== 'No').map(option => {
  return {
    label: option,
    value: option.toLowerCase()
  }
})
